import Vue from 'vue'
import VueBreadcrumbs from 'vue-2-breadcrumbs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import i18n from './i18n'
import { sync } from 'vuex-router-sync'
import './plugins/vuetify-mask'
import './plugins/aps'
import './services/axios.interceptors'
import VueMask from 'v-mask'
import filters from './plugins/filters'
import permissions from '@/mixins/permissions'
import snackbarMessage from '@/mixins/snackbar-message'
import './registerServiceWorker'
import mobileScreen from '@/mixins/mobile-screen'

Vue.use(VueAxios, axios)
Vue.use(VueMask, filters)
Vue.use(VueBreadcrumbs)
Vue.mixin(permissions)
Vue.mixin(snackbarMessage)
Vue.mixin(mobileScreen)

Vue.config.productionTip = false
// Чат FAKT Support - custom element со своего хоста, Vue его не компилирует.
Vue.config.ignoredElements = ['fakt-support-widget']

sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
